<script>
    import { onMount } from 'svelte';
    import { firebase, firestore } from "../firebase/firebase.js";
    import { Navigate, Route, navigateTo } from 'svelte-router-spa';
    import langs from "../langs.js"
    import { setLoader } from "../store/shared.js";
    import { theRoute, updateLanguagePanel, setLiveCountries } from "../store/shared"
    import { user, userProfile } from "../store/auth.js";

    var liveCountries = [];
    var loader = false;
    var rfLoader = false;
    var currentLang = '';
    var currentCountry = '';

    $: {
        if ($user && $userProfile) {
            init();
        }

        if ($updateLanguagePanel) {
            refreshLanguages();
            updateLanguagePanel.update(old => !old)
        }
    }

    async function init() {
        loader = true;
        await fetchLiveCountries();
        loader = false;
        currentLang = $theRoute.childRoute.namedParams["lang"];
        currentCountry = $theRoute.childRoute.namedParams["countryId"];
    }


    async function fetchLiveCountries() {
        var query = firestore.collection('countries').where('is_live', '==', true);
        var res = await query.get();
        if (res && res.docs && res.docs.length != 0) {
            var temp = [];
            for (let i = 0; i < res.docs.length; i++) {
                const country = res.docs[i];
                const allLanguages = getAllLang(country.id, country.data()['languages']);
                const liveLanguages = getLiveLangs(country.data()['live_languages'], allLanguages);


                if ($user && $userProfile && $userProfile.role == 'manager' && $userProfile.countries) {
                    if ($userProfile.countries[country.id]) {
                        temp.push({
                            id: country.id,
                            ...country.data(),
                            languages: allLanguages,
                            liveLanguages: liveLanguages.filter(l => $userProfile.countries[country.id].includes(l.code)),
                        })
                    }
                } else {
                    temp.push({
                        id: country.id,
                        ...country.data(),
                        languages: allLanguages,
                        liveLanguages: liveLanguages,
                    })
                }
            }
            liveCountries = temp
            setLiveCountries(liveCountries)
        } else {
            liveCountries = [];
            setLiveCountries(liveCountries)
        }
    }

    function getAllLang(countryId, rawLangs) {
        var list = [];
        try {
            if (countryId && rawLangs && rawLangs.length) {
                for (let i = 0; i < rawLangs.length; i++) {
                    const lang = rawLangs[i];
                    if (lang) {
                        for (const key in lang) {
                            if (lang.hasOwnProperty(key)) {
                                const langObj = lang[key];
                                list.push({
                                    code: key,
                                    ...langObj
                                })
                            }
                        }
                    }
                }
            }
        } catch (error) {

        }
        return list;
    }

    function getLiveLangs(live, all) {
        var list = [];
        try {
            if (live && live.length > 0 && all && all.length > 0) {
                for (let i = 0; i < live.length; i++) {
                    const liveLangCode = live[i];
                    var found = all.find(lang => lang['code'] == liveLangCode)
                    if (found) {
                        list.push(found)
                    }
                }
            }
        } catch (error) {

        }
        return list;
    }



    async function refreshLanguages() {
        rfLoader = true;
        await fetchLiveCountries();
        rfLoader = false;
    }

    function changeLanguage(lang, countryId) {
        setLoader(true);
        currentLang = lang;
    }


</script>

<div class="lp-main">
    <div class="row"
        style="color: gray; display: flex; justify-content: space-between; align-items: center; padding: 0px 10px 0 15px">
        <div class="display:block;" style="display: flex; align-items: center; ">
            <i class="fa fa-language"></i>
            <span style="font-size: 13px; padding-left: 5px;"> Countries</span>
        </div>
        {#if rfLoader == false}
        <button on:click="{refreshLanguages}" type="button" class="btn btn-link btn-sm"><i
            class="fa fa-sync-alt text-muted"></i></button>
        {:else}
        <button class="btn btn-link btn-sm" type="button" disabled>
            <span class="spinner-border text-secondary spinner-border-sm" role="status" aria-hidden="true"></span>
            <span class="sr-only">Refreshing</span>
          </button>
        {/if}
    </div>
    <hr>

    <div class="row">
        {#if loader == false}
            {#if liveCountries && liveCountries.length != 0}
                <ul class="list-group list-group-flush" style="width: 100% !important;">
                    {#each liveCountries as country, i}
                        <i style="text-align: left !important; font-size: 13px; width: 100% !important;" class:list-group-item="{true}" class:list-group-item-action="{true}">
                            <b>{ country['name'] }</b>
                            <ul class="list-group list-group-flush" style="margin-top: 15px; width: 100% !important;">
                                {#each country['liveLanguages'] as lang, i}
                                    <Navigate to="{'/admin/country/' + country['id'] + '/' + lang['code'] + '/decks'}">
                                        <button title="{lang['name']}" on:click="{changeLanguage(lang['code'], country['id'])}" class="my_language"
                                            class:active="{currentLang == lang['code']}" class:list-group-item="{true}" class:list-group-item-action="{true}">
                                            { lang['name'] }
                                        </button>
                                    </Navigate>
                                {/each}
                            </ul>
                        </i>                            
                    {/each}
                </ul>
            {:else}
                <div style="width: 100%; display: flex; font-size: 13px;">
                    <span class="text-secondary" style="text-align: center; width: 100%;">No countires</span>
                </div>
            {/if}
        {:else}
            <div style="width: 100%;">
                <div class="d-flex justify-content-center">
                    <div class="spinner-grow text-secondary" role="status">
                    <span class="sr-only">Loading...</span>
                    </div>
                </div>
            </div>
        {/if}
    </div>

</div>

<style>
    .lp-main {
        padding: 10px;
        overflow-y: auto;
        overflow-x: hidden;
        border-left: 1px solid #f4f4f4;
        border-right: 1px solid #f4f4f4;
        height: calc(100% - 36px);
        height: 100%;
        min-height: 100%;
    }

    .my_language{
        text-align: left !important;
        font-size: 13px;
        width: 100% !important;
        max-width: 100% !important;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis !important;
    }
    
</style>